<template>
    <div class="container-render-post">
         <div class="render-post hide-scrollbar render-post-facebook">
            <div class="post-content">
                <div class="post-header">
                    <div class="img-pages">

                        <template v-for="(picturePage, index) in picturePages.slice(0,picturePages.length == 4 ? 4 : 3)">
                            <Tooltip :active="picturePage.iconEdited" :key="index" :text="'Voir les modifications apportées'" position="right" :classCustom="`page ${picturePage.iconEdited ? 'iconEdited' : ''}`" @click="()=>{$emit('clickPage', picturePage.id)}">
                                <img :src="picturePage && picturePage.avatar ? picturePage.avatar : 'img/avatar.jpg'" alt="">
                            </Tooltip>
                        </template>

                        <div class="page count" v-if="picturePages.length > 4">
                            +{{ picturePages.length - 3 }}
                        </div>
                    </div>

                    <div class="info">
                        <p class="name" v-if="picturePages.length == 1">{{ pageName }}</p>
                        <div class="date">{{ datePost ? dateFormatPost : 'A l\'instant' }} • <i class="fa-solid fa-earth-americas"></i></div>
                    </div>
                    <div class="more"><i class="fa-solid fa-ellipsis"></i></div>
                </div>
                <div class="post-text" v-if="text">
                    <p v-html="textTranslateMentionAndHastag"></p>
                </div>

                <div class="snippet" v-if="snippet.link">
                    <SnippetNetwork :link="snippet.link" :titleDefault="snippet.title" :imageUrlDefault="snippet.imageUrl" :descriptionDefault="snippet.description"></SnippetNetwork>
                </div>
                <div v-else-if="medias.filter(media => media).length" :class="'post-medias media'+medias.length">
                    <div class="media" v-for="(media,i) in medias.slice(0,4)" :class="{videoPreview:['video/mp4'].includes(media.type)}" v-if="media" :key="media.id">
                        <div class="count" v-if="i == 3 && medias.length > 4">+{{ medias.length - 3}}</div>

                        <template v-if="['video/mp4'].includes(media.type)">
                            <img v-if="media.imagePreview" :src="media.imagePreview.url" alt="" class="video">
                            <video v-else muted playsinline preload="metadata" class="video" onloadedmetadata="this.muted = true">
                                <source :src="media.url" type="video/mp4">
                            </video>
                        </template>
                        <img v-else :src="media.url" alt="">
                    </div>
                </div>

                <div class="post-empty" v-if="!text && !medias.length && !snippet.link"></div>
                <div class="post-footer">
                    <div class="reaction">
                        <i class="fa-regular fa-thumbs-up"></i>
                        J'aime
                    </div>
                    <div class="comments">
                        <i class="fa-regular fa-comment"></i>
                        Commenter
                    </div>
                    <div class="share">
                        <i class="fa-regular fa-share"></i>
                        Partager
                    </div>
                </div>
                <div class="comment-first" v-if="comment">
                    <img :src="!picturePages || !picturePages.length || picturePages.length > 1 || !picturePages[0] ?  'img/avatar.jpg' : picturePages[0].avatar" alt="">
                    <div class="content-comment">
                        <div class="auteur"><i class="fa-solid fa-microphone-stand"></i>Auteur</div>
                        <p class="page-name" v-if="picturePages.length == 1">{{ pageName }}</p>
                        <p class="comment" v-html="commentTranslateMentionAndHastag"></p>
                    </div>
        
                </div>
            </div>
        </div>

        <SelectPlace v-if="modes.includes('addPlaceMode')" 
            @close="closeContentOverflow"
            :placeSelected="place"
            :position="positionFormOverlay"
            :network="'facebook'"
        />
    </div>


   
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from '../SnippetNetwork.vue'
    import Tooltip from '../../tooltip/tooltipInit.vue'
    import SelectPlace from '../formOverlay/selectPlace.vue';

    export default {
        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip,
            SelectPlace
        },

        props: {
            picturePages: {
                type: Array,
                default: () => [] 
            },
            pageName : {
                type: String,
                default: ''
            },
            text : {
                type: String,
                default: ''
            },
            comment : {
                type: String,
                default: ''
            },
            datePost: {
                default: 1315349759920 
            },
            medias: {
                type: Array,
                default: ()=>[] 
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : "",
                    title: "",
                    description: "",
                    domaine:"",
                    imageUrl:""
                })
            },
            
            mentions : {
                type: Object,
                default: ()=>({})
            },

            modes: {
                type: Array,
                default:()=>[] 
            },

            positionFormOverlay: {
                type: String,
                default: 'left'
            },

            place: {
                type: Object,
                default: undefined
            },
        },

        methods: {
            closeContentOverflow() {
                EventBus.$emit('postCreatorRemoveMode', 'all')
            },
        },

        watch: {
        },

        computed: {
            dateFormatPost() {
                let dateMessage = this.datePost
                if (typeof dateMessage !== "object") {
                    dateMessage = new Date(dateMessage)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
                    return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                    
                }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
                }else{
                    return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
                }
            },

            textTranslateMentionAndHastag() {
                //return this.text
                return this.text.replace(/#\w+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.facebook ? `<span class="mention">@${mention.mention.facebook.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            },

            commentTranslateMentionAndHastag() {
                //return this.text
                return this.comment.replace(/#\w+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.facebook ? `<span class="mention">@${mention.mention.facebook.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            }
        },
    }
</script>
